import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';

const DonationError = () => {
    const navigate = useNavigate();

    return (
        <div className="donation-error__shell">
            <div className="donation-error__card">
                <FontAwesomeIcon icon={faTimesCircle} className="donation-error__icon" />
                <h1 className="donation-error__heading">Something Went Wrong</h1>
                <p className="donation-error__body">
                    We were unable to process your donation. Please try again later or contact us at{' '}
                    <a href="mailto:admin@fobk.org">admin@fobk.org</a>.
                </p>
                <div className="donation-error__actions">
                    <a href="mailto:admin@fobk.org" className="btn donation-error__contact-btn">
                        Email admin@fobk.org
                    </a>
                    <Button color="secondary" onClick={() => navigate('/')}>
                        Return to Platform
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default DonationError;
